module.exports = __webpack_public_path__ + "img/appstoredowload.99bbf76c.png";